import React from "react";
import BerufsmantelPrimo from "../Garments/BerufsmantelPrimo";

export default function BerufsmantelPrimoPage() {
  return <BerufsmantelPrimo />;
}
